import React from 'react';
import styles from './field-error.module.scss';
interface Props {
    message?: string;
}
export const FieldError: React.FC<Props> = ({ message }) => {
    return message ? <div className={styles.fieldError}>{message}</div> : null;
};
